import React from "react";
import HeaderBar from "../../../components/Header/HeaderBar";
import ContentWrapper from "../../../components/ContentWrapper";
import { useSearchParams } from "react-router-dom";
import UnsubscribeForm from "../../../components/Modals/UnsubscribeForm";

const CancelPage = () => {
  const [searchParams] = useSearchParams();
  let subId = searchParams.get("subId");
  return (
    <div className="flex flex-col items-center">
      <HeaderBar title="Cancel Your Subscription" />
      <ContentWrapper>
        <UnsubscribeForm subscriptionId={subId} />
      </ContentWrapper>
    </div>
  );
};
export default CancelPage;
